import { Component, OnInit ,Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import { MAT_CHECKBOX_CLICK_ACTION } from '@angular/material';
import { DataApiService } from 'src/app/Services/data-api.service';

/*excel*/
import *  as Excel from 'exceljs/dist/exceljs.min.js';
import * as FileSaver from 'file-saver';

export interface DialogData { 
  id:string
}
@Component({
  selector: 'app-descargar-reporte-usuario',
  templateUrl: './descargar-reporte-usuario.component.html',
  styleUrls: ['./descargar-reporte-usuario.component.scss'],
  providers:[
    {provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    {provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'check'}    
  ]
})
export class DescargarReporteUsuarioComponent implements OnInit {

  constructor(
    private dataApi : DataApiService,
    public dialogRef: MatDialogRef<DescargarReporteUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  public descargar={
    idUser:this.data,
    desde:null,
    hasta:null
  }
  dateAfterFrom= null;
  minHastaDate(e){
    const date = new Date(e);
    this.dateAfterFrom = new Date(date.getFullYear(), date.getMonth(), date.getDate());

  }
  observacion_reporte:boolean=false;
  descargarReporteDesdeUsuario(){
    this.dataApi.descargarReporteDesdeUsuario(this.descargar).subscribe((data)=>{
      if(data["total_count"]== 0){
        this.observacion_reporte=true;
      }else{       
        this.observacion_reporte=false;
        const items = data["items"];
        const desde = data["desde"];
        const hasta = data["hasta"];
        const razon_social = data["razon_social"][0].razon_social;
        items.map((dato)=>{
          dato.retorno = (dato.retorno == 0) ? "NO" :"SI";
          dato.cod = (dato.cod == 0) ? "NO" :"SI";
          dato.tipoPago = (dato.tipoPago == 0) ? "Factura" :"Boleta";
          return dato;
       })
       this.exportToExcel(items,desde,hasta,razon_social);   
      }
    })
  }
  exportToExcel(data,desde,hasta,razon_social){
    const rowInicioRegistro =8;
    var workbook = new Excel.Workbook();
    workbook.creator = "web";
    workbook.lastModifiedBy = "web";
    workbook.created = new Date();
    workbook.modified =  new Date();
    workbook.addWorksheet('SheetTest', { views: [{ activeCell: 'A1', showGridLines: true }] })
    var sheet = workbook.getWorksheet(1);

    sheet.mergeCells('B1:B3');
    

    sheet.mergeCells('C1:D1');
    sheet.getCell('C1').value="JM";
    sheet.getCell('C1').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 14,
      italic: false,
      bold:true
    }

    sheet.mergeCells('C2:D2');
    sheet.getCell('C2').value="Cal. German Schereiber 276 Int. 240, San Isidro, Lima";
    sheet.getCell('C2').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }

    sheet.mergeCells('C3:D3');
    sheet.getCell('C3').value="RUC.: 20603477015";
    sheet.getCell('C3').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }

    sheet.mergeCells('A5:G5');
    sheet.getCell('A5').value=`Reporte de servicios ${razon_social}`;
    sheet.getCell('A5').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 14,
      italic: false,
      bold:true
    }
    sheet.getCell('A5').alignment = { vertical: 'middle', horizontal: 'center' };

    sheet.mergeCells('A6:G6');
    sheet.getCell('A6').value= `Del ${desde} hasta ${hasta} `;
    sheet.getCell('A6').font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }
    sheet.getCell('A6').alignment = { vertical: 'middle', horizontal: 'center' };

   
    sheet.getRow(rowInicioRegistro).border ={
      top: {style:'thin'},
      left: {style:'thin'},
      bottom: {style:'thin'},
      right: {style:'thin'}
    }
    sheet.getRow(rowInicioRegistro).values = [
            'ID Pedido',
            'Nombre',
            'Apellido',
            'Área',
            'Lugar de recojo',
            'Fecha de recojo',
            'Hora de recojo',
            'Observaciones recojo',
            'Lugar de entrega',
            'Fecha de entrega',
            'Hora de entrega',
            'Observaciones entrega',
            'COD',
            'Retorno',
            'Precio',
            'Precio Convenio',
            'Tipo de Comprobante',
            'RUC Factura',
            'Razón Social Factura',
            'Descripción',
            'Día del pedido',
            'Hora del pedido'          
    ]; 
    sheet.getRow(rowInicioRegistro).height= 25;
    sheet.getRow(rowInicioRegistro).alignment= { vertical: 'middle', horizontal: 'center' };
    sheet.getRow(rowInicioRegistro).font ={
      name:'Arial',
      color: { argb: '00000000' },
      family: 2,
      size: 10,
      italic: false,
      bold:true
    }
    sheet.columns = [
      { key: 'id_pedido',width:10 },
      { key: 'name',width:30 },
      { key: 'surname',width:30 },
      { key: 'area',width:30 },
      { key: 'lugarRecojo',width:50 },
      { key: 'fechaRecojo',width:20 },
      { key: 'horaRecojo',width:20 },
      { key: 'observaciones_recojo',width:40 },
      { key: 'lugarEntrega',width:50 },
      { key: 'fechaEntrega',width:20 },
      { key: 'horaEntrega',width:20 },
      { key: 'observaciones_entrega',width:40 },
      { key: 'cod',width:10 },
      { key: 'retorno',width:10 }, 
      { key: 'precio',width:20 },    
      { key: 'precio_convenio',width:20 },
      { key: 'tipoPago',width:25 },
      { key: 'RUCFactura',width:20 },
      { key: 'RazonSocialFactura',width:50 },
      { key: 'descripcion',width:70 },
      { key: 'dia_pedido',width:20 },
      { key: 'hora_pedido',width:20 }
    ];       
    sheet.addRows(data);

    

    workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' }); 
      FileSaver.saveAs(blob, `reporte-${razon_social}-${desde}-${hasta}.xlsx` );
    });
  }
  ngOnInit() {  
  }

}
